enum DirectionValue {
  PREV = `prev`,
  NEXT = `next`
}

enum Animation {
  WITHOUT = `without`,
  START = `start`,
  IN_PROGRESS = `in progress`,
  FINISHED = `finished`,
}

enum Mode {
  IN_ORDER = `in order`,
  TARGET = `target`
}

enum Action {
  TO_RIGHT = `to-rigth`,
  TO_LEFT = `to-left`,
  UNDEFINED = `undefined`
}

export {DirectionValue, Animation, Mode, Action};
